import React from "react";

function Italic() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="italic" className="svg-inline--fa fa-italic fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M208 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M158.75 96h82.5l-80 320h-82.5z"></path></g></svg>
    );
  }

export default Italic;